import { Switch } from 'native-base';
import type { IToggleComponentType } from './Toggle.types';

const Toggle = Switch as IToggleComponentType;

export { Toggle };
export * from './Toggle.types';
